import { AfterViewInit, Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

declare var $;
@Component({
  selector: 'custom-footer',
  templateUrl: 'custom-footer.html',
  inputs: ['footerData']
})
export class CustomFooterPage implements AfterViewInit {

  footerData: any;
  table: any = null;
  constructor(public navCtrl: NavController, public navParams: NavParams) {
    setTimeout(() => {
      this.beautifyTable();
    }, 100);
  }

  ionViewWillEnter() {

  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.beautifyTable();
    }, 500);
    setTimeout(() => {
      this.beautifyTable();
    }, 1000);
  }



  beautifyTable() {
    $(document).ready(() => {
      $('.dynamic-table').each(function () {
        if (!$.fn.dataTable.isDataTable(this)) {
          $(this).DataTable({
            "paging": false,
            "info": false,
            "searching": false,
            "sorting": false,
            "order": []
          });
        }
      });
    });

  }

}




// WEBPACK FOOTER //
// ./src/components/custom-footer/custom-footer.ts